export default __webpack_public_path__ + "static/media/Natalie_Vecchione_AHV_In_Moms_We_Trust.37a54b78.jpg";